import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import Button from "components/utils/button"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import {SchoolClass} from "models"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"

/**
 * @typedef {object} UpgradeLicnseButtonProps
 * @property {unknown} hasPro
 * @property {unknown} onUpgradeSchoolClassPressed
 * @property {unknown} schoolClass
 */

/** @typedef {object} UpgradeLicnseButtonState */

/**
 * @extends {ShapeComponent<UpgradeLicnseButtonProps, UpgradeLicnseButtonState>}
 */
class UpgradeLicnseButton extends ShapeComponent {
  static propTypes = {
    hasPro: PropTypes.bool.isRequired,
    schoolClass: PropTypes.instanceOf(SchoolClass).isRequired
  }

  setup() {
    const {t} = useI18n({namespace: "js.components.school_classes.upgrade_license_button"})

    this.t = t
  }

  render() {
    const {hasPro, schoolClass, ...restProps} = this.props

    return (
      <Button
        dataSet={this.buttonDataSet ||= {component: "upgrade-license-button", schoolClassId: schoolClass.id()}}
        onPress={this.tt.onPress}
        title={hasPro ? this.t(".change_subscription") : this.t(".upgrade_license")}
        {...restProps}
      />
    )
  }

  onPress = () => {
    this.p.onUpgradeSchoolClassPressed({schoolClass: this.p.schoolClass})
  }
}

export default memo(shapeComponent(UpgradeLicnseButton))
